export namespace ClientLogos {
	let setupClientLogos = () => {
		let clientLogosModules = document.querySelectorAll('.js-client-logos');

		if(!clientLogosModules.length) {
			return;
		}
		let pauseIcons = document.querySelectorAll('.js-logos-pause');

		if (clientLogosModules.length) {
			clientLogosModules.forEach((clientLogoModule, index) => {
				//check how many logo elements we have
				let numberOfElements = clientLogoModule.querySelectorAll('.cl-client-logos__slide').length;
				let track = clientLogoModule.querySelector('.cl-client-logos__track');
				let duplication = parseInt(track.getAttribute('data-duplication'), 10);
				let speed = clientLogoModule.getAttribute("data-speed");

				// Create a <style> tag and add it to the head on the fly. We do this because we cant calculate the math that the animation needs otherwise
				let keyframe = document.createElement('style');
				keyframe.type = 'text/css';
				keyframe.innerHTML = `@keyframes scroll${index} {  0% { transform: translateX(0); } 100% { transform: translateX( ${-211 * (numberOfElements / duplication)}px ) }  }`;
				document.head.appendChild(keyframe);

				//set the appropriate width and animation for each client logo section
				track.setAttribute('style', `width: ${211 * numberOfElements}px; animation: scroll${index} ${speed}s linear infinite`);

			});
		}

		if (pauseIcons.length) {
			pauseIcons.forEach((icon) => {
				let container = icon.closest('.cl-client-logos__container');
				let carousel = container.querySelector('.cl-client-logos');

				if (carousel.classList.contains('cl-client-logos--black')) {
					icon.classList.add('cl-client-logos__pause--light');
				}

				icon.addEventListener('click', () => {
					container.classList.toggle('cl-client-logos__container--pause');
					icon.classList.toggle('cl-client-logos__pause--play');
				})
			});
		}
	}

	export const init = () => {
		setupClientLogos();
	}
}

